import api from "./api";

class AuthService {
  login = async (mother_user_identification, username, password) => {
    let userInfos = { user_type: null, username: null };
    const response = await api.post("/auth/token/obtain/", {
      mother_user_identification,
      username,
      password,
    });
    if (response.data.access) {
      localStorage.setItem(
        "userLM",
        JSON.stringify({ ...response.data, ...userInfos })
      );
      const userTypeResponse = await api.get("/user/type/");
      userInfos = userTypeResponse.data;
      localStorage.setItem(
        "userLM",
        JSON.stringify({ ...response.data, ...userInfos })
      );
    }

    return { ...response.data, ...userInfos };
  };

  loginOperator = async (mother_user_identification, username, password) => {
    let userInfos = { user_type: null, username: null };
    const response = await api.post("/auth/token/obtain/with-mother-id/", {
      mother_user_identification,
      username,
      password,
    });

    if (response.data.access) {
      localStorage.setItem(
        "userLM",
        JSON.stringify({ ...response.data, ...userInfos })
      );
      const userTypeResponse = await api.get("/user/type/");
      userInfos = userTypeResponse.data;
      localStorage.setItem(
        "userLM",
        JSON.stringify({ ...response.data, ...userInfos })
      );
    }

    return { ...response.data, ...userInfos };
  };

  logout = () => {
    localStorage.removeItem("userLM");
  };

  register = async (username, first_name, last_name, email, password) => {
    return await api.post("/register/", {
      username,
      first_name,
      last_name,
      email,
      password,
    });
  };

  requestPasswordReset = async (email) => {
    return await api.post("/auth/password-reset/request/", { email });
  };

  validateResetToken = async (token) => {
    return await api.get(`/auth/password-reset/confirm/?token=${token}`);
  };

  confirmPasswordReset = async (token, new_password1, new_password2) => {
    return await api.post("/auth/password-reset/confirm/", {
      token,
      new_password1,
      new_password2,
    });
  };
}

export default new AuthService();
